/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerRenameBodyExpectedCustomerVersionExclusiveMin = 0;
export const customerRenameBodyExpectedCustomerVersionMax = 9007199254740991;

export const CustomerRenameBody = zod.object({
  name: zod.string(),
  expectedCustomerVersion: zod
    .int()
    .gt(customerRenameBodyExpectedCustomerVersionExclusiveMin)
    .max(customerRenameBodyExpectedCustomerVersionMax),
});

export type CustomerRenameBody = zod.input<typeof CustomerRenameBody>;
export type CustomerRenameBodyOutput = zod.output<typeof CustomerRenameBody>;
